import moment from 'moment';
import Cookies from 'universal-cookie';

const getStartDayWithTimeZone = (date) => {
  const cookies = new Cookies();
  const timezone = cookies.get('organization')?.timezone;

  return moment.tz(date, timezone).startOf('day').format('YYYY-MM-DDTHH:mm:ssZ');
};

export default getStartDayWithTimeZone;
